export default __webpack_public_path__ + "static/media/membership1.c6bec597.jpg";